import request from '@/CommonDP/utils/request';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from '@/CommonDP/utils/globalParams.js';
export default {
  // 最近文档模块
  getUserRecentViewFiles(pageNum, pageSize, enterpriseId, keyword) {
    return request
      .get(
        `/file/getUserRecentViewFiles?pageNum=${pageNum}&pageSize=${pageSize}&enterpriseId=${enterpriseId}&keyword=${keyword}`
      )
      .then((res) => res);
  },
  getNotationDic(prjID, fileId) {
    if (!globalParams.get('isHky')) { return request.get(`/drawing-annotation/dicList?prjId=${prjID}&fileId=${fileId}`); } else {
      return request.get(`${globalParams.get('queryNotationDicReq')}?prjId=${prjID}&fileId=${fileId}`);
    }
  },
  getFilterDic(prjId) {
    if (!globalParams.get('isHky')) { return request.get(`/drawing-annotation/getFilterConditions?prjId=${prjId}`); } else {
      return request.get(`${globalParams.get('queryFilterDicReq')}?prjId=${prjId}`);
    }
  },
  picupload(params) {
    return request.post('/pic/upload', params).then((res) => res);
  },
  notationAdd(params) {
    return request
      .post('/drawing-annotation/add', params)
      .then((res) => res);
  },
  notationEdit(data) {
    return request.post('/lc/drawing-annotation/update', data);
  },
  notationlist(params) {
    if (globalParams.get('isHky')) {
      return request.post(`${globalParams.get('queryNotationlistReq')}`, params);
    }
    // 自定义接口地址
    const newUrl = globalParams.get("url:/drawing-annotation/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post(`/drawing-annotation/list`, params);
  },
  drawingannotationupdateStatus(data) {
    return request
      .post('/drawing-annotation/updateStatus', data)
      .then((res) => res);
  },
  drawingQuestionDelete(ids) {
    return request
      .post(`/drawing-annotation/delete`, ids)
      .then((res) => res);
  },
  getDrawingQuestionDetails(questionId, flowInstanceId, shareId) {
    if (!globalParams.get('isHky')) { return request.get(`/drawing-annotation/getById?id=${questionId}&flowInstanceId=${flowInstanceId || ''}&shareId=${shareId || ''}`); } else {
      return request.get(`${globalParams.get('queryQuestionDetailsReq')}?id=${questionId}`);
    }
  },
  drawingDrawingQuesExport(params) {
    return request({
      responseType: 'blob',
      url: '/drawing-annotation/export',
      method: 'post',
      data: params
    });
  },
  // 添加到最近文档
  recentViewRecordAdd(fileId, fileVersion) {
    return request
      .get(
        `/recentViewRecord/add?fileId=${fileId}&fileVersion=${fileVersion}`
      )
      .then((res) => res);
  }
};
